import React from 'react'
import PropTypes from 'prop-types'
import { Transition } from '@tailwindui/react'

/**
 * Sidebar mobile
 */
function SidebarMobile ({ children, isOpen, setIsOpen, logo }) {
  return (
    <div className='md:hidden'>
      <Transition show={isOpen} className='fixed inset-0 flex z-40'>
        {/* Background overlay */}
        <Transition.Child
          enter='transition-opacity ease-linear duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='transition-opacity ease-linear duration-300'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
          className='fixed inset-0'
        >
          <div className='absolute inset-0 bg-gray-600 opacity-75' onClick={() => setIsOpen(false)} />
        </Transition.Child>

        {/* Sliding sidebar */}
        <Transition.Child
          enter='transition ease-in-out duration-300 transform'
          enterFrom='-translate-x-full'
          enterTo='translate-x-0'
          leave='transition ease-in-out duration-300 transform'
          leaveFrom='translate-x-0'
          leaveTo='-translate-x-full'
          className='relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white'
        >
          <div className='absolute top-0 right-0 -mr-14 p-1'>
            <button className='flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600' aria-label='Close sidebar' onClick={() => setIsOpen(!isOpen)}>
              <svg className='h-6 w-6 text-white' stroke='currentColor' fill='none' viewBox='0 0 24 24'>
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12' />
              </svg>
            </button>
          </div>
          <div className='flex-shrink-0 flex items-center px-8'>
            {logo}
          </div>
          <div className='flex-1 h-0 overflow-y-auto'>
            {children}
          </div>
          <div className='flex-shrink-0 w-14'>
            {/* Dummy element to force sidebar to shrink to fit close icon */}
          </div>
        </Transition.Child>
      </Transition>
    </div>
  )
}

export default SidebarMobile
